import React, { useEffect, useState } from "react";
import { Ticket } from "lucide-react";

const LAUNCH = new Date("2026-11-02T00:00:00+02:00").getTime();

const remaining = () => {
  const ms = Math.max(0, LAUNCH - Date.now());
  return {
    done: ms === 0,
    days: Math.floor(ms / 86400000),
    hrs: Math.floor(ms / 3600000) % 24,
    min: Math.floor(ms / 60000) % 60,
    sec: Math.floor(ms / 1000) % 60,
  };
};

const Unit = ({ value, label }) => (
  <div className="flex flex-col items-center min-w-[38px] sm:min-w-[48px]">
    <span data-testid={`countdown-${label.toLowerCase()}`} className="font-hero text-lg sm:text-2xl font-bold text-white leading-none tabular-nums">
      {String(value).padStart(2, "0")}
    </span>
    <span className="font-mono-data text-[9px] sm:text-[10px] uppercase tracking-[0.2em] text-[#C9A55C] mt-1">{label}</span>
  </div>
);

export const ComingSoonRibbon = () => {
  const [t, setT] = useState(remaining());
  useEffect(() => {
    const id = setInterval(() => setT(remaining()), 1000);
    return () => clearInterval(id);
  }, []);

  if (t.done) return null;

  return (
    <div data-testid="coming-soon-ribbon" className="w-full bg-[#0A2540] px-3 py-2 flex justify-center">
      <div className="flex items-stretch w-full max-w-3xl rounded-lg overflow-hidden border border-white/10 bg-[#161B22] shadow-lg">
        <div className="bg-[#C9A55C] flex items-center justify-center px-3 sm:px-5 border-r-2 border-dashed border-[#161B22]">
          <Ticket className="h-6 w-6 sm:h-7 sm:w-7 text-[#161B22]" />
        </div>
        <div className="flex flex-1 flex-wrap items-center justify-between gap-x-4 gap-y-2 px-3 sm:px-5 py-2">
          <div>
            <p className="font-mono-data text-[9px] sm:text-[11px] uppercase tracking-[0.25em] text-[#C9A55C]">Launch Ticket</p>
            <p className="font-hero text-xl sm:text-3xl font-bold uppercase text-white leading-tight">Coming Soon</p>
          </div>
          <div data-testid="launch-countdown" className="flex items-center gap-1 sm:gap-2">
            <Unit value={t.days} label="Days" />
            <Unit value={t.hrs} label="Hrs" />
            <Unit value={t.min} label="Min" />
            <Unit value={t.sec} label="Sec" />
          </div>
          <div data-testid="launch-date" className="text-right font-hero font-bold text-white leading-tight">
            <p className="text-base sm:text-xl">02 November</p>
            <p className="text-sm sm:text-lg">2026</p>
          </div>
        </div>
      </div>
    </div>
  );
};
